/* eslint-disable */
/* @flow */

import * as Animatable from 'react-native-animatable'
import React, { Component } from 'react'
import LottieView from 'lottie-react-native'
import { Image, TouchableOpacity, TouchableWithoutFeedback, Text, View, Platform, Dimensions, Keyboard, Animated, TextInput } from 'react-native'
import { NavigationActions } from 'react-navigation';
import { connect } from 'react-redux'
//import { LoginManager, AccessToken } from 'react-native-fbsdk'
import { Images, Fonts } from '../Themes';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scrollview'
import styles from './Styles/AuthenticationScreenStyle'
import anim from '../Images/animations/marquee.json';
import AuthActions from '../Redux/AuthRedux'
import BaseScreen from "./BaseScreen";
import { alertView, getDeviceLanguage } from '../Lib/utils';
import { SvgBackButton } from '../Components/SvgComponent'

import API from '../Services/Api'
import FixtureAPI from '../Services/FixtureApi'
import DebugConfig from '../Config/DebugConfig'

//import TwitterShare from '../Lib/TwitterShare'

import { isIPhoneX } from '../Lib/utils'
import I18n from "i18n-js"

let { width, height } = Dimensions.get('window')

let actualBrowserWidth = width

if (Platform.OS == 'web' && width > 800) width = 800

let leftOffset = (actualBrowserWidth - width)/2
if (leftOffset < 0) leftOffset = 0 

const isIPhone5 = Math.abs(width - 320) < 0.1 // or 5S / SE small screen

// these are old style like 6 and 6+ not tall
const isIPhonePlus = (Math.abs(width - 414) < 0.1 && Math.abs(height - 736) < 0.1)
const isIPhone6 = (Math.abs(width - 375) < 0.1 && Math.abs(height - 667) < 0.1)// 6/6S (but also for X so no good)
const isIPhone11orXR = (Math.abs(width - 414) < 0.1 && Math.abs(height - 896) < 0.1)

class AuthenticationScreen extends Component {

  constructor(props) {
    console.log("auth screen constructor")
    super(props)
    this.props.navigation.state.key = 'AuthenticationScreen'
  
    this.state = { accessToken: '', width : width, height : height, errorString : false }

    this.api = DebugConfig.useFixtures ? FixtureAPI : API.create( )
    const language = getDeviceLanguage()
    //this.api.setLanguage(language)
    this.logoWidth = new Animated.Value(this.isIpad() ? 0.7 : 1) // ipad (1 for iphone)
    this.logoOffset = new Animated.Value(0) // ipad (1 for iphone)
    this.offsetUpForKeyboard = new Animated.Value(0) // ipad (1 for iphone)

    this.animatedMargin = new Animated.Value(this.state.width * (this.isIpad() ? 0.0 : 0.1)) // was 0.1 iphone
    this.animatedBottomMargin = new Animated.Value(width * 0.1)
    this.animatedOpacity = new Animated.Value(1)
    this.animatedOne = new Animated.Value(1) // for 1 - x
    this.animatedNegOne = new Animated.Value(-1) // for -1 * x
    // https://stackoverflow.com/questions/31578069/repeat-animation-with-new-animated-api
    /* no longer are doing the oscillate between 2 images, but leave here in case needed because it is a pain to set up
    Animated.loop(Animated.timing(this.animatedOpacity, {toValue: 0, duration: 3000, easing: (t) => {  
      let out = 0;
      if (t<0.4) out = 0;
      if (t>=0.4 && t<0.5) out = (t-0.4)*10;
      if (t>=0.5 && t < 0.9) out = 1;
      if (t>=0.9) out = (1-(t-0.9)*10);
      return out;
    } } )).start( )
    */
    this.performLoginAttempt = this.performLoginAttempt.bind(this)
    // if this screen comes up, make sure we are logged out of twitter
    // this the only place in the kargoe app where we log out of twitter 
    if (false)
    TwitterShare.logout({}).then(result => {
       console.log('logged out of lingering twitter which can cause endless trouble later')
    }).catch(error => { // this is not working if, say, twitter app is not installed
       // might get this if twitter app is not installed; not a problem.
    })
  }

  componentDidMount( ) {
    console.log("auth screen did mount")
    this.KBListeners = [ Keyboard.addListener('keyboardDidShow', this.keyboardDidShow.bind(this))
                       , Keyboard.addListener('keyboardDidHide', this.keyboardDidHide.bind(this))
                       ]
  }
  componentWillUnmount( ) {
    this.KBListeners.forEach( listener => listener.remove ( ) )
  }
  isIpad = ( ) => { // just go by aspect ratio for now, but may have to consider newer ipads different dimensions so use iphone 5 ratio as cutoff
    return (this.state.height / this.state.width) < (568.0/320.0 * 0.95)
  }

  keyboardDidShow = ( ) => {
    /* move up
    const isIPhone5 = Math.abs(this.state.width - 320) < 0.1 // or 5S / SE small screen
    const isIPhonePlus = (Math.abs(this.state.width - 414) < 0.1 && Math.abs(this.state.height - 736) < 0.1)
    const isIPhone6 = (Math.abs(this.state.width - 375) < 0.1 && Math.abs(this.state.height - 667) < 0.1)// 6/6S (but also for X so no good)
    */

    let offsetUpForKeyboardFinal = -170
    if (isIPhoneX()) offsetUpForKeyboardFinal = -300 // was 300 ok for biggest phones
    if (isIPhonePlus) offsetUpForKeyboardFinal = -160
    if (isIPhone6) offsetUpForKeyboardFinal = -120
    if (isIPhone5) offsetUpForKeyboardFinal = -100

    if (!isIPhone5) offsetUpForKeyboardFinal = 0.8 * offsetUpForKeyboardFinal

    console.log("isIPhonePlus = " + isIPhonePlus)

    Animated.timing(this.logoWidth, { toValue : this.isIpad() ? 0.7 : (/*isIPhone5 ? 0.3 :*/ 0.5), duration : 250, useNativeDriver: false }).start( )
    Animated.timing(this.logoOffset, { toValue : isIPhone5 ? -150 : -180, duration : 250, userNativeDriver: false }).start( )
    // there is an anim conflict for the big login button because it is a touchable (animated) opacity which is running native driver
    // so this has to be on native driver or crash sometimes (red screen)
    Animated.timing(this.offsetUpForKeyboard, { toValue : offsetUpForKeyboardFinal, delay: 0, duration : 250, useNativeDriver: true }).start( )

    // use 0.12 to accomodate iphone x notch
    Animated.timing(this.animatedMargin, { toValue : -this.state.width * (isIPhoneX() ? 0.05 : 0.05), duration : 250 }).start( )
    //Animated.timing(this.animatedBottomMargin, { toValue : this.state.width * 0.1, duration : 250 }).start( )
  }
  keyboardDidHide = ( ) => {
    Animated.timing(this.logoWidth, { toValue : this.isIpad() ? 0.7 : 1, duration : 250, useNativeDriver: false }).start( ) // 1 for iphone
    Animated.timing(this.logoOffset, { toValue : 0, duration : 250, useNativeDriver: false }).start( )
    Animated.timing(this.offsetUpForKeyboard, { toValue : 0, delay: 300, duration : 250, useNativeDriver: true }).start( )

    Animated.timing(this.animatedMargin, { toValue : this.state.width * (this.isIpad() ? 0.0 : 0.1), duration : 250 }).start( ) // 0.1 for iphone
    //Animated.timing(this.animatedBottomMargin, { toValue : this.state.width * 0.1, duration : 250 }).start( )
  }

  performLoginAttempt = ( ) => {
    const language = getDeviceLanguage()
    //this.api.setLanguage(language)
    this.api.login( this.username, this.password )
    .then(resp => {
      //alertView("performLoginAttempt", JSON.stringify(resp)) // debug crash when building on prod
      if( resp.data && resp.data.data && resp.data.errors && resp.data.errors.length ) {
        this.setState({ errorString : resp.data.errors[0].detail })
        this.passwordRef.focus() // keep focus/keyboard in case there is an error
      } else if( resp.ok ) {
				this.setState({ errorString : false })
				console.log(`AuthenticationScreen calling nonSagaLogin`)
        this.props.nonSagaLogin( resp )
      }
    })
    .catch(e => {
      //alertView("performLoginAttempt", JSON.stringify(e)) // debug crash when building on prod
      this.setState({ errorString : "Serious program or server error, contact admin" })
      console.warn(e)
    })
  }

  onNavigatorEvent = (event) => { }

  componentWillReceiveProps(nextProps) {

    // Signup to facebook flow occurs if the login fails
    if(this.props.error !== nextProps.error && nextProps.error !== null
        && nextProps.error.detail === "User does not exist")
      this.onFacebookSignup( )

  }

  initUser = async (token) => {
    return await fetch('https://graph.facebook.com/v2.5/me?fields=email,name,first_name,last_name&access_token=' + token)
      .then(response => response.json())
      .catch(() => {
        reject('ERROR GETTING DATA FROM FACEBOOK')
      })
  }
  onFacebookSignup = () => {
    alertView('Signup with Facebook not supported', 'Please sign up for Kargoe with your email address instead')
    return
    this.initUser(this.state.accessToken).then((json) => {
      const dataApi = {
        facebookToken: this.state.accessToken,
        facebookUserId: this.state.userId,
        username: json.email.split("@")[0],
        email: json.email,
        firstName :json.first_name,
        lastName : json.last_name
      }
      this.props.navigation.navigate('signupFacebook', { data: dataApi })
    })
  }
  onFacebookLoginPress = () => {
    LoginManager.logOut()
    LoginManager.logInWithPermissions([
      'email',
      'public_profile' /*, no friends yet, requires more review by FB
      'user_friends', */
    ]).then((result) => {

      if (!result.isCancelled) {
        AccessToken.getCurrentAccessToken().then(
          (data) => {
            const { accessToken, userID } = data
            this.setState({ accessToken, userId: userID })
            const dataApi = { facebookToken: accessToken, facebookUserId: userID }
            this.props.loginFacebook(dataApi)
          }
        )
      }

    })
  }

  onSignUpPress = () => {
    // this.props.navigation.navigate('signup')
    this.props.navigation.dispatch(NavigationActions.reset({
        index: 0,
        key: null,
        actions: [NavigationActions.navigate({ routeName: 'signup' })] // signup bioSetup
    }))
  }
  onSignInPress = () => this.props.navigation.navigate('login')
  onForgotPassPress = () => this.props.navigation.navigate('forgetPass')

  
  render() {
    console.log("auth screen render")
    let defaultForegroundColor = 'black'
    let logoAspect = 969/669
      , loginAspect = 591/114
      , loginFBAspect = 579/114
      , width = this.state.width
      , height = this.state.height
      , buttonWidth = this.state.width * 0.6
      , textStyle = { color : {defaultForegroundColor}, fontSize : 18, fontFamily : Fonts.style.font.boldLogin }
      , formStyle = { ...textStyle
                    , width : width * 0.9
                    , height : 25, lineHeight : 25
                    , marginTop : width * 0.05, marginBottom : width * 0.025
                    , borderBottomWidth : 1, borderColor : defaultForegroundColor
                    }

    /* moved up
    const isIPhone5 = Math.abs(width - 320) < 0.1 // or 5S / SE small screen
    const isIPhone6 = (Math.abs(width - 375) < 0.1 && Math.abs(height - 667) < 0.1)// 6/6S (but also for X so no good)
    const isIPhonePlus = Math.abs(width - 414) < 0.1 // 6/6S
    */

    console.log("auth width = " + width + " ip5 = " + isIPhone5)
    const buttonFontSizeStyle = isIPhone5 ? {fontSize:14, lineHeight: 17, height: 17} : {fontSize:17, lineHeight: 19, height: 19} // default otherwise
    // , height : buttonWidth / loginAspect
    const inputProps      = {
      keyboardType: 'default',
      autoCapitalize: 'false',
      autoCorrect: false,
      blurOnSubmit: true,
      returnKeyType: 'next'
    }
    let textRowHeight = 50

    let msgFontSize = (isIPhone5 || isIPhone6) ? 14 : 20
    // This background image is also used on the auto-logout part of SettingsScreen.js

    let largeTextHeightScale = isNaN(this.logoWidth) ? 1 : this.logoWidth
    // 812 is iphone x height for ref
    let maxLargeFont = 30 // 42  (38 ok on 8 and 8plus not ok on 11, 34 ok on 11, 30 ok on 11 pro)

    if (isIPhonePlus || isIPhone6) maxLargeFont = 38
    else if (isIPhone11orXR) maxLargeFont = 34

    maxLargeFont = 42 // back to orig

    let largeFontSize = maxLargeFont * (height / 812) // isNaN(this.logoWidth) ? 46 : (46 * this.logoWidth)
    largeFontSize = largeFontSize > maxLargeFont ? maxLargeFont : largeFontSize
    console.log("largeFontSize = " + largeFontSize)
    console.log("formStyle.width = " + formStyle.width)

    let loginBottomGraphicStyle = { position: 'absolute', top: height - 100, width : '50%', height: 70}
    let mainWidth = this.state.width
    if (Platform.OS == 'web') {
      // if we get too small vertically, get rid of this
      loginBottomGraphicStyle = { position: 'absolute', bottom: 10, width : '50%', height: height < 700 ? 0 : 70}
      // login screen goes crazy when too wide
      //if (mainWidth > 500) mainWidth = 500
    }

    const isWeb = Platform.OS == 'web'

    // https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser

    let mobileCheck = function() {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    };

    const isMobile = mobileCheck()

    return (
      <BaseScreen darkStatusbar style={[styles.container, {backgroundColor: 'white'}]}>

        <Image source={Images.loginBackground}
               style={{ width : 0 /*this.state.width*/, height : 0 /*this.state.height*/
                      , position : 'absolute', zIndex : -1, top : 0, left : 0 }}
               resizeMode='cover' />

        <View style={{ flex : 1, height : this.state.height, width : this.state.width, flexDirection : 'column', alignItems : 'center', justifyContent : 'flex-start', backgroundColor: 'white', position: 'absolute', left: leftOffset}}>

          <Animated.View source={Images.loginLogoOther} resizeMode='contain'
            style={{ width : (width * 0.9) , height : largeTextHeightScale * width / logoAspect, marginBottom : -width * 0.05
                    , marginTop : this.animatedMargin, transform : [{ scale : this.logoWidth }, {translateX : this.logoOffset} ], opacity: 1}}>

              <Text maxFontSizeMultiplier={1} style={{fontFamily :  Fonts.style.font.extraBoldLogin, fontSize: largeFontSize}}> </Text>
              <Text maxFontSizeMultiplier={1} style={{fontFamily :  Fonts.style.font.extraBoldLogin, fontSize: largeFontSize}}>KARGOE FOR A</Text>
              <Text maxFontSizeMultiplier={1} style={{fontFamily :  Fonts.style.font.extraBoldLogin, fontSize: largeFontSize}}>BETTER</Text>
              <Text maxFontSizeMultiplier={1} style={{fontFamily :  Fonts.style.font.extraBoldLogin, fontSize: largeFontSize}}>COMMUNITY</Text>

              <View style={{ flexDirection : 'row' }}>
              <Text maxFontSizeMultiplier={1} style={{fontFamily :  Fonts.style.font.extraBoldLogin, fontSize: largeFontSize}}>AND</Text>
              <Text maxFontSizeMultiplier={1} style={{marginLeft: 10, fontFamily :  Fonts.style.font.extraBoldLogin, fontSize: largeFontSize, color: '#a0fa01'}}>BETTER LIFE</Text>
              </View>

          </Animated.View>



          <Animated.View style={{ flexDirection : 'column', alignItems : 'center', justifyContent : 'space-between'
                                  , marginTop : !isWeb ? this.animatedMargin : 50, marginBottom : this.animatedBottomMargin, transform : [{ translateY : (height < 900 && !isMobile) ? -300 : 0}] }}>

            { this.state.errorString &&
              <Text maxFontSizeMultiplier={1} style={{ position: 'absolute', fontSize : 16, color : 'red', fontWeight : 'bold', margin : 15, top: isIPhone5 ? -60 : -25 }}>
                {this.state.errorString}
              </Text>
            }
            <TextInput maxFontSizeMultiplier={1} {...inputProps} style={ [formStyle, {fontSize : 15, fontFamily :  Fonts.style.font.italicBoldLogin, paddingBottom: 0, height: 40}, isIPhone5?{top:-50}:{}] } onChangeText={username => this.username = username} placeholder={I18n.t('login.username')} placeholderTextColor={'#cccccc'} autoCapitalize='false' onSubmitEditing={() => this.passwordRef.focus()} />
            <TextInput maxFontSizeMultiplier={1} {...inputProps} returnKeyType='go' ref={ref => {this.passwordRef = ref}} style={ [formStyle, {fontSize : 15, fontFamily :  Fonts.style.font.italicBoldLogin, height: 40}, isIPhone5?{top:-50}:{}] } onChangeText={password => this.password = password} placeholder={I18n.t('login.password')}  placeholderTextColor={'#cccccc'} secureTextEntry={true} onSubmitEditing={this.performLoginAttempt} />
          </Animated.View>



          <View style={[{ flexDirection : 'row', width : formStyle.width, height: 40, flex : 1 , top: (isIPhone5 ? -80 : -30)}, 
                        {/*alignItems : 'flex-start', /*justifyContent : 'space-between',*/ left: 0}
                       ]  }>
            <TouchableOpacity onPress={this.onSignUpPress.bind(this)} activeOpacity={0.5} style={{flex:0.5, height:30}}>
              <Text maxFontSizeMultiplier={1} style={[{ ...textStyle, ...buttonFontSizeStyle, fontFamily : Fonts.style.font.extraBoldLogin}, {height: 40}]}>{I18n.t('login.signUp')}</Text>
            </TouchableOpacity>
            {!this.props.isAddProfile && <TouchableOpacity onPress={this.onForgotPassPress.bind(this)} activeOpacity={0.5} style={{flex:0.5, height:30}}>
              <Text maxFontSizeMultiplier={1} style={[{ ...textStyle, ...buttonFontSizeStyle, fontFamily : Fonts.style.font.extraBoldLogin}, {height: 40, textAlign : 'right'}]}>{I18n.t('login.forgotpass')}</Text>
            </TouchableOpacity>}
          </View>

          {/*
          <TouchableOpacity onPress={this.onFacebookLoginPress.bind(this)} activeOpacity={0.5} 
          style={{ position: 'absolute', top: (isIPhone5 ? 0.75*height : 0.80*height), margin : 10, padding : 0, paddingBottom: 5, justifyContent : 'center', alignItems : 'center', 
          paddingBottom : 0, height: 0}}>
           
            <Text style={[{ ...textStyle, 
                            fontSize : (isIPhone5 ? 10 : 12)
                          },
                          (false && isIPhone5) ? {height:34} : {}
                         ]}>{(isIPhone5 && false) ?  I18n.t('login.prevFBIP5') : I18n.t('login.prevFB')}</Text>
            <Text style={{textAlign: 'center', height: 30}}> 
            <Text style={{ ...textStyle, fontWeight : 'bold', fontSize : 14 }}>{I18n.t('login.prevFB2')}</Text>
            <Text style={{ ...textStyle, fontSize : 12 }}> {I18n.t('login.prevFB3')}</Text>
            </Text>
          
          </TouchableOpacity>
          */}

          <TouchableOpacity onPress={this.performLoginAttempt} activeOpacity={0.5} 
                            style={{ position: 'absolute', top:  (isIPhone5 ? /*0.65: 0.70*/ 0.75 : 0.80)*height, margin : 10, padding : 0, /*top: (isIPhone5 ? -50 : 0) ,*/
                            transform : [ {translateY : this.offsetUpForKeyboard} ]}}>
            <View source={Images.loginButton} resizeMode='contain' style={{ backgroundColor: 'rgba(255, 255, 255, 0.0)', width : formStyle.width+2, height: 49 }}/>
            <View style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, justifyContent: 'center', alignItems: 'center'}}>
                <Text style={{fontFamily : Fonts.style.font.extraBoldLogin, fontSize: 28, color: 'black', paddingBottom: 4}}>{I18n.t('login.login')}</Text> 
              </View>
          </TouchableOpacity>

          <Image source={Images.loginIconRow}
               style={loginBottomGraphicStyle}
               resizeMode='contain' />

        </View>

				{this.props.isAddProfile &&
					<TouchableOpacity style={{position: 'absolute', top: 30, left: 10, padding: 5, justifyContent: 'center', alignItems: 'center'}} 
						onPress={() => this.props.cancelAddProfile()}>
						<SvgBackButton />
					</TouchableOpacity>}

      </BaseScreen>
    )
  }
}

const mapStateToProps = (state) => {

  return {
    fetching: state.auth.fetching,
    error: state.auth.error,
		user: state.auth.user,
		isAddProfile: state.auth.authBackup && state.auth.authBackup.user
  }

}
const mapDispatchToProps = (dispatch) => {
  return {
    loginFacebook: (data) => dispatch(AuthActions.facebookLoginRequest(data)),
    signupFacebook: (data) => dispatch(AuthActions.facebookSignupRequest(data)),
    nonSagaLogin: success => dispatch(AuthActions.authSuccess(success)),
    cancelAddProfile: () => dispatch(AuthActions.cancelAddProfileRequest()),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationScreen)
